import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Link } from "react-router-dom";

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: "blur(24px)",
  border: "1px solid",
  borderColor: theme.palette.divider,
  backgroundColor: alpha(theme.palette.background.default, 0.4),
  boxShadow: theme.shadows[1],
  padding: "8px 12px",
}));

export default function AppAppBar() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        boxShadow: 0,
        bgcolor: "transparent",
        backgroundImage: "none",
        mt: 5,
      }}
    >
      <Container maxWidth="lg">
        <StyledToolbar variant="dense" disableGutters>
          <Box
            sx={{ flexGrow: 1, display: "flex", alignItems: "center", px: 0 }}
          >
            <Button variant="text" color="warning" size="small">
              <Link to={{ pathname: "/" }}>Launch Core</Link>
            </Button>
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <Button variant="text" color="info" size="small">
                <Link to={{ pathname: "/", hash: "features" }}>Features</Link>
              </Button>
              <Button variant="text" color="info" size="small">
                <Link to={{ pathname: "/", hash: "testimonials" }}>
                  Testimonials
                </Link>
              </Button>
              <Button variant="text" color="info" size="small">
                <Link to={{ pathname: "/", hash: "highlights" }}>
                  Highlights
                </Link>
              </Button>
              <Button variant="text" color="info" size="small">
                <Link to={{ pathname: "/", hash: "pricing" }}>Pricing</Link>
              </Button>
              <Button
                variant="text"
                color="info"
                size="small"
                sx={{ minWidth: 0 }}
              >
                <Link to={{ pathname: "/", hash: "faq" }}>FAQ</Link>
              </Button>
              <Button variant="text" color="info" size="small">
                <Link to={"/blog"}>Blog</Link>
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 1,
              alignItems: "center",
            }}
          >
            <Button color="primary" variant="text" size="small">
              <Link to={"/sign-in"}>Sign in</Link>
            </Button>
            <Button color="primary" variant="contained" size="small">
              <Link to={"/sign-up"}>Sign up</Link>
            </Button>
          </Box>
          <Box sx={{ display: { sm: "flex", md: "none" } }}>
            <IconButton aria-label="Menu button" onClick={toggleDrawer(true)}>
              <MenuIcon />
            </IconButton>
            <Drawer anchor="top" open={open} onClose={toggleDrawer(false)}>
              <Box sx={{ p: 2, backgroundColor: "background.default" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <IconButton onClick={toggleDrawer(false)}>
                    <CloseRoundedIcon />
                  </IconButton>
                </Box>
                <Divider sx={{ my: 3 }} />
                <MenuItem>
                  <Link to={{ pathname: "/", hash: "features" }}>Features</Link>
                </MenuItem>
                <MenuItem>
                  <Link to={{ pathname: "/", hash: "testimonials" }}>
                    Testimonials
                  </Link>
                </MenuItem>
                <MenuItem>
                  <Link to={{ pathname: "/", hash: "highlights" }}>
                    Highlights
                  </Link>
                </MenuItem>
                <MenuItem>
                  {" "}
                  <Link to={{ pathname: "/", hash: "pricing" }}>Pricing</Link>
                </MenuItem>
                <MenuItem>
                  {" "}
                  <Link to={{ pathname: "/", hash: "faq" }}>FAQ</Link>
                </MenuItem>
                <MenuItem>
                  {" "}
                  <Link to={"/blog"}>Blog</Link>
                </MenuItem>
                <MenuItem>
                  <Button color="primary" variant="contained" fullWidth>
                    Sign up
                  </Button>
                </MenuItem>
                <MenuItem>
                  <Button color="primary" variant="outlined" fullWidth>
                    Sign in
                  </Button>
                </MenuItem>
              </Box>
            </Drawer>
          </Box>
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}
